import z from "zod";
import { MeasurementType } from "modules/common/components/Alarms/constants";

export const createRangeInputSchema = (measurementType?: MeasurementType) => {
    const isAirTemperature = measurementType === MeasurementType.AirTemperature;

    return z
        .object({
            min: z
                .union([z.number(), z.undefined()], {
                    invalid_type_error: "Donja granica mora biti broj",
                })
                .refine(val => val != null, {
                    message: "Donja granica je obavezna",
                })
                .refine(val => val != null && Number.isFinite(val), {
                    message: "Donji prag mora biti valjan broj",
                })
                .refine(val => isAirTemperature || val == null || val >= 0, {
                    message: "Donji prag ne može biti negativan",
                }),
            max: z
                .union([z.number(), z.undefined()], {
                    invalid_type_error: "Gornja granica mora biti broj",
                })
                .refine(val => val != null, {
                    message: "Gornja granica je obavezna",
                })
                .refine(val => val != null && Number.isFinite(val), {
                    message: "Gornji prag mora biti valjan broj",
                }),
        })
        .refine(data => !(data.min === 0 && data.max === 0), {
            message: "Donji i gornji prag ne mogu oba biti 0",
            path: ["min"],
        })
        .refine(data => data.min != null && data.max != null && data.max > data.min, {
            message: "Gornji prag mora biti veći od donjeg praga",
            path: ["max"],
        });
};

export const rangeInputSchema = createRangeInputSchema();
